<form (ngSubmit)="onSubmit()" [formGroup]="searchProducts">
    <div class="flex items-center" mat-dialog-title>
      <h2 class="headline m-0 flex-auto">{{'SELECT_PRODUCT.TEXT'|translate}}</h2>
      <button
        class="text-secondary"
        mat-dialog-close
        mat-icon-button
        type="button">
        <mat-icon svgIcon="mat:close"></mat-icon>
      </button>
    </div>
  
    <mat-divider class="text-border"></mat-divider>
  
    <!-- Scrollable content -->
    <mat-dialog-content class="dialog-content">
      <div class="flex sm:flex-col">
        <mat-form-field class="flex-1">
          <input
            [formControl]="searchCtrl"
            matInput
            [placeholder]="'SEARCH.TEXT' | translate"
            type="search" />
          <mat-icon matIconSuffix class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
        </mat-form-field>
      </div>
  
      <div class="flex sm:flex-col">
        <mat-radio-group formControlName="selectedValue">
          <div *ngFor="let product of filteredProducts">
            <mat-radio-button [value]="product" class="flex-auto">
              {{ product.code }} - {{ product.name }}
            </mat-radio-button>
          </div>
        </mat-radio-group>
      </div>
    </mat-dialog-content>
  
    <!-- Sticky actions -->
    <mat-dialog-actions align="end" class="dialog-actions">
      <button mat-flat-button type="button" color="primary" (click)="onCancel()">
        {{ "CANCEL.TEXT" | translate }}
      </button>
      <button mat-flat-button type="submit" color="primary" [disabled]="!searchProducts.valid">
        {{ "SAVE.TEXT" | translate }}
      </button>
    </mat-dialog-actions>
  </form>
  